import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';

interface PictureSortDropdownAttrs {
    sort: string
    onchange: (value: string) => void
}

export default class PictureSortDropdown implements ClassComponent <PictureSortDropdownAttrs> {
    view(vnode: Vnode<PictureSortDropdownAttrs, this>) {
        const sortOptions: { [key: string]: string } = {};

        ['latest', 'oldest'].forEach(key => {
            sortOptions[key] = extractText(app.translator.trans('kilowhat-formulaire.forum.submission-sort.' + key));
        });

        const activeValue = (vnode.attrs.sort || Object.keys(sortOptions)[0]);

        return m(Dropdown, {
            buttonClassName: 'Button',
            label: sortOptions[vnode.attrs.sort] || Object.keys(sortOptions).map(key => sortOptions[key])[0],
            icon: 'fas fa-sort-amount-' + (activeValue === 'latest' ? 'up' : 'down'),
        }, Object.keys(sortOptions).map(value => {
            const label = sortOptions[value];
            const active = activeValue === value;

            return m(Button, {
                icon: active ? 'fas fa-check' : true,
                onclick: () => {
                    vnode.attrs.onchange(value);
                },
                active,
            }, label);
        }));
    }
}
